<script lang="ts">
	import posthog from 'posthog-js';
	import { browser, dev } from '$app/env';
	import CookieConsentBanner from '#lib/common/Presentation/CookieConsent/CookieConsentBanner.svelte';
	import { beforeNavigate, afterNavigate } from '$app/navigation';
	import { page, updated } from '$app/state';
	import Toolbar from '#lib/components/Toolbar/Toolbar.svelte';
	import { getPresetById } from '#lib/feature/ApplicationSetting/domain/colorPresets.js';
	import 'driver.js/dist/driver.css';

	interface Props {
		data: import('./$types').LayoutData;
		children?: import('svelte').Snippet;
	}

	let { data, children }: Props = $props();

	if (browser) {
		beforeNavigate(({ shallow, type }) => {
			if (shallow && type === 'goto') return;

			return posthog.capture('$pageleave');
		});

		afterNavigate(({ shallow, type }) => {
			if (shallow && type === 'goto') return;

			return posthog.capture('$pageview');
		});
	}

	if (page.url.searchParams.get('signedOut') === 'True') {
		posthog.capture('logout', {
			user_id: page.data.session?.user_id
		});
		posthog.reset();
	}

	beforeNavigate(({ willUnload, to, shallow, type }) => {
		if (shallow && type === 'goto') return;

		if (updated.current && !willUnload && to?.url) {
			location.href = to.url.href;
		}
	});

	const themeStyle = $derived.by(() => {
		const s = data.applicationSetting;
		if (!s) {
			return '';
		}

		const rootVars: string[] = [];
		const darkVars: string[] = [];

		if (s.colorPreset) {
			const preset = getPresetById(s.colorPreset);
			if (preset) {
				rootVars.push(`--primary: ${preset.primaryLight}`);
				darkVars.push(`--primary: ${preset.primaryDark}`);
			}
		} else if (s.primaryColor) {
			rootVars.push(`--primary: ${s.primaryColor}`);
			darkVars.push(`--primary: ${s.primaryColor}`);
		}

		if (s.borderRadius) {
			rootVars.push(`--radius: ${s.borderRadius}`);
		}

		if (rootVars.length === 0) {
			return '';
		}

		let css = `:root { ${rootVars.join('; ')}; }`;
		if (darkVars.length > 0) {
			css += ` .dark { ${darkVars.join('; ')}; }`;
		}
		return css;
	});
</script>

<svelte:head>
	{#if browser && !dev}
		<script
			defer
			src="https://umami.amatignon.fr/script.js"
			data-website-id="94a3f4c5-fb40-4e58-9760-6c5c6754e6f0"
		></script>
	{/if}

	{#if themeStyle}
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html `<style>${themeStyle}</style>`}
	{/if}
</svelte:head>

<CookieConsentBanner />

<div>
	{@render children?.()}
</div>
{#if dev}
	<Toolbar />
{/if}
